module.exports = __webpack_public_path__ + "gy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gy.svg
// module id = 844
// module chunks = 0